// 依頼新規モード
export enum ReceptionCreateKinds {
  Normal = 0,
  Quote = 1,
  Copy = 2,
  QuoteDetail = 3,
  CopyDetail = 4,
}
